module.exports = {"title":"GoGoVan - Terms and Conditions","tc_consumer_headline":"Terms and Conditions"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/sg/setting/tc_consumer/locale.json
// module id = 720
// module chunks = 0 1 2 3 4 5